import { useGetEditorialGuidelinesQuery } from "@/app/features/config/configApiSlice";
import ConfigWrapper from "@/pages/configuration/components/ConfigWrapper";
import ShowHtmlContent from "@/pages/configuration/components/ShowHtmlContent";
import { CircularProgress, Typography } from "@mui/material";

function EditorialGuidelinesPage() {
  const { data, isLoading, error } = useGetEditorialGuidelinesQuery();

  if (isLoading) {
    return <CircularProgress />;
  }

  if (error) {
    return (
      <Typography align="center" sx={{ mb: 3 }} variant="h3">
        Something went wrong
      </Typography>
    );
  }

  return (
    <ConfigWrapper title="Editorial Guidelines">
      <ShowHtmlContent
        content={data?.data?.editorialGuidelinesDetail}
      />
    </ConfigWrapper>
  );
}

export default EditorialGuidelinesPage;
